const AOS = require("../../../node_modules/aos/dist/aos.js")

export const start = async function() {
    await delay(500);
    AOS.init()
    return
}


// funcão caso precise remover algo da memória ao final da aplicação
export const stop = async function() {
    return
}

async function delay(n) {
    n = n || 2000;
    return new Promise(done => {
        setTimeout(() => {
            done();
        }, n);
    });
}
